import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "portal-page auth-page my-info-page" }
const _hoisted_2 = { class: "page-shell auth-page__shell" }
const _hoisted_3 = { class: "auth-form__body" }
const _hoisted_4 = { class: "auth-form__section" }
const _hoisted_5 = {
  key: 0,
  class: "auth-form__field"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 1,
  class: "auth-form__field"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "auth-form__field my-info-form__account-action" }
const _hoisted_10 = { class: "auth-form__section" }
const _hoisted_11 = { class: "auth-form__field" }
const _hoisted_12 = ["onKeydown"]
const _hoisted_13 = { class: "auth-form__field" }
const _hoisted_14 = ["onKeydown"]
const _hoisted_15 = { class: "auth-form__field" }
const _hoisted_16 = { class: "auth-form__field" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "auth-form__msg auth-form__msg--warn"
}
const _hoisted_19 = {
  key: 1,
  class: "auth-form__msg auth-form__msg--ok"
}
const _hoisted_20 = {
  key: 2,
  class: "auth-form__hint"
}
const _hoisted_21 = { class: "auth-form__field" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "auth-form__msg auth-form__msg--muted"
}
const _hoisted_24 = {
  key: 1,
  class: "auth-form__msg auth-form__msg--ok"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 2,
  class: "auth-form__hint"
}
const _hoisted_27 = { class: "auth-form__field" }
const _hoisted_28 = { class: "auth-form__addr-stack" }
const _hoisted_29 = { class: "auth-form__field-row" }
const _hoisted_30 = ["value"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "auth-form__section" }
const _hoisted_34 = { class: "auth-form__field" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "auth-form__field" }
const _hoisted_37 = { class: "auth-form__field" }
const _hoisted_38 = { class: "auth-form__section" }
const _hoisted_39 = { class: "auth-form__field" }
const _hoisted_40 = ["onKeydown"]
const _hoisted_41 = {
  key: 0,
  class: "auth-form__msg auth-form__msg--warn"
}
const _hoisted_42 = { class: "auth-form__section" }
const _hoisted_43 = { class: "auth-form__field" }
const _hoisted_44 = { class: "auth-form__field-row" }
const _hoisted_45 = ["disabled", "onKeydown"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 1,
  class: "auth-form__msg auth-form__msg--warn"
}
const _hoisted_48 = {
  key: 2,
  class: "auth-form__msg auth-form__msg--ok"
}
const _hoisted_49 = {
  key: 0,
  class: "auth-form__field"
}
const _hoisted_50 = { class: "auth-form__field-row" }
const _hoisted_51 = ["disabled", "onKeydown"]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  key: 0,
  class: "auth-form__hint"
}
const _hoisted_54 = { class: "auth-form__msg auth-form__msg--ok" }
const _hoisted_55 = {
  key: 0,
  class: "auth-form__verify-timer"
}
const _hoisted_56 = {
  key: 0,
  class: "auth-form__msg auth-form__msg--warn"
}
const _hoisted_57 = {
  key: 1,
  class: "auth-form__msg auth-form__msg--ok"
}
const _hoisted_58 = { class: "auth-form__field" }
const _hoisted_59 = { class: "auth-form__field-row" }
const _hoisted_60 = ["disabled", "onKeydown"]
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 1,
  class: "auth-form__msg auth-form__msg--warn"
}
const _hoisted_63 = {
  key: 2,
  class: "auth-form__field"
}
const _hoisted_64 = { class: "auth-form__field-row" }
const _hoisted_65 = ["disabled", "onKeydown"]
const _hoisted_66 = ["disabled"]
const _hoisted_67 = {
  key: 0,
  class: "auth-form__hint"
}
const _hoisted_68 = { class: "auth-form__msg auth-form__msg--muted" }
const _hoisted_69 = {
  key: 0,
  class: "auth-form__verify-timer"
}
const _hoisted_70 = {
  key: 0,
  class: "auth-form__msg auth-form__msg--warn"
}
const _hoisted_71 = {
  key: 3,
  class: "auth-form__msg auth-form__msg--ok"
}
const _hoisted_72 = { class: "auth-form__actions" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = ["disabled"]

import { computed, onMounted, reactive, ref, watch } from 'vue'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import {
  fetchBizGubunList,
  updateMemberProfile,
  uploadMemberBizCert,
  type BizGubunOption,
} from '@/api/member'
import BizGubunPicker from '@/components/member/BizGubunPicker.vue'
import { MEMBER_REFUND_BANKS } from '@/constants/banks'
import { useDaumPostcode } from '@/composables/useDaumPostcode'
import { useMemberAuth } from '@/composables/useMemberAuth'
import { useVerification } from '@/composables/useVerification'
import { filterBizGubunOptions, isExcludedBizGubun, parseBizGubun, serializeBizGubun } from '@/utils/bizGubun'
import {
  collectProfileValidationErrors,
  deferredInputValidationState,
  shouldShowNameFormatWarning,
  inputValidationState,
  isAddressDetailValid,
  isAddressValid,
  bizNumberFieldState,
  bizNumberInputError,
  formatBizNumberInput,
  isBizNumberInputValid,
  isEmailValid,
  isNameValid,
  isOrgCodeValid,
  isOrgNameValid,
  isPhoneValid,
  isRefundAccountValid,
  isRefundHolderValid,
  isVerifyCodeValid,
  isZipcodeValid,
  sanitizeDigitsInput,
  sanitizeNameInput,
  sanitizeOrgNameInput,
} from '@/utils/formValidation'


export default /*@__PURE__*/_defineComponent({
  __name: 'MyInfoPage',
  setup(__props) {

const API_ORIGIN = (process.env.VUE_APP_API_ORIGIN || '').replace(/\/$/, '')

const router = useRouter()
const { member, logout, withdraw, setMember } = useMemberAuth()
const isKakaoMember = computed(() => member.value?.loginType === 'kakao')
const kakaoAccountLabel = computed(() =>
  member.value?.oauthEmail ? `카카오 계정 · ${member.value.oauthEmail}` : '카카오 계정',
)
const withdrawing = ref(false)
const emailVerification = useVerification('profile')
const phoneVerification = useVerification('profile')
const { opening: postcodeOpening, searchPostcode } = useDaumPostcode()

const form = reactive({
  orgName: '',
  orgCode: '',
  bizGubun: [] as string[],
  name: '',
  email: '',
  emailCode: '',
  phone: '',
  phoneCode: '',
  bizNum: '',
  bizCert: '',
  zipcode: '',
  address: '',
  addressDetail: '',
  refundBank: '',
  refundAccount: '',
  refundHolder: '',
})

const bizCertUploading = ref(false)
const bizCertHref = computed(() =>
  form.bizCert ? `${API_ORIGIN}${form.bizCert}` : '',
)

const originalEmail = ref('')
const originalPhone = ref('')
const originalSnapshot = ref('')
const isSubmitting = ref(false)
const skipLeaveGuard = ref(false)
const bizGubunOptions = ref<BizGubunOption[]>([])
const bizGubunLoading = ref(false)
const bizGubunLoadError = ref('')
const nameTouched = ref(false)
const formSubmitAttempted = ref(false)

const orgNameRef = ref<HTMLInputElement | null>(null)
const orgCodeRef = ref<HTMLInputElement | null>(null)
const nameRef = ref<HTMLInputElement | null>(null)
const emailRef = ref<HTMLInputElement | null>(null)
const emailCodeRef = ref<HTMLInputElement | null>(null)
const phoneRef = ref<HTMLInputElement | null>(null)
const phoneCodeRef = ref<HTMLInputElement | null>(null)

const focusInput = (target: { value: HTMLInputElement | HTMLSelectElement | null }) => {
  target.value?.focus()
}

const normalizeEmail = (value: string) => value.trim().toLowerCase()

const snapshotForm = () =>
  JSON.stringify({
    orgName: form.orgName,
    orgCode: form.orgCode,
    bizGubun: serializeBizGubun(form.bizGubun),
    name: form.name,
    email: form.email,
    phone: form.phone,
    bizNum: form.bizNum,
    bizCert: form.bizCert,
    zipcode: form.zipcode,
    address: form.address,
    addressDetail: form.addressDetail,
    refundBank: form.refundBank,
    refundAccount: form.refundAccount,
    refundHolder: form.refundHolder,
  })

const isDirty = computed(() => snapshotForm() !== originalSnapshot.value)

const isEmailChanged = computed(() => normalizeEmail(form.email) !== originalEmail.value)
const isPhoneChanged = computed(() => form.phone !== originalPhone.value)

const isEmailReady = computed(() => !isEmailChanged.value || emailVerification.verified)
const isPhoneReady = computed(() => !isPhoneChanged.value || phoneVerification.verified)

const bizGubunOptionsWithLegacy = computed(() => {
  const options = [...bizGubunOptions.value]

  parseBizGubun(member.value?.bizGubun).forEach((value) => {
    if (isExcludedBizGubun(value)) {
      return
    }

    if (!options.some((item) => item.value === value)) {
      options.push({
        value,
        label: `${value} (기존)`,
        groupName: '',
      })
    }
  })

  return filterBizGubunOptions(options)
})

const orgNameInputState = computed(() =>
  inputValidationState(form.orgName, isOrgNameValid(form.orgName)),
)

const orgCodeInputState = computed(() =>
  inputValidationState(form.orgCode, isOrgCodeValid(form.orgCode)),
)

const nameInputState = computed(() =>
  deferredInputValidationState(
    form.name,
    isNameValid(form.name),
    nameTouched.value,
    formSubmitAttempted.value,
  ),
)

const showNameWarning = computed(() =>
  shouldShowNameFormatWarning(form.name, nameTouched.value, formSubmitAttempted.value),
)

const emailInputState = computed(() =>
  inputValidationState(form.email, {
    isValid: isEmailReady.value,
    isInvalid: Boolean(form.email) && !isEmailValid(form.email),
  }),
)

const emailCodeInputState = computed(() =>
  inputValidationState(form.emailCode, isVerifyCodeValid(form.emailCode)),
)

const phoneInputState = computed(() =>
  inputValidationState(form.phone, {
    isValid: isPhoneReady.value,
    isInvalid: Boolean(form.phone) && !isPhoneValid(form.phone),
  }),
)

const phoneCodeInputState = computed(() =>
  inputValidationState(form.phoneCode, isVerifyCodeValid(form.phoneCode)),
)

const isEmailInputLocked = computed(
  () =>
    isEmailChanged.value &&
    (emailVerification.sending || emailVerification.verified || emailVerification.codeSent),
)

const isPhoneInputLocked = computed(
  () =>
    isPhoneChanged.value &&
    (phoneVerification.sending || phoneVerification.verified || phoneVerification.codeSent),
)

const applyMemberToForm = () => {
  if (!member.value) {
    return
  }

  form.orgName = member.value.orgName || ''
  form.orgCode = member.value.longtermCode || ''
  form.bizGubun = parseBizGubun(member.value.bizGubun)
  form.name = member.value.bossName || ''
  form.email = member.value.bossEmail || ''
  form.phone = member.value.bossPhone || ''
  form.bizNum = formatBizNumberInput(member.value.bizNum || '')
  form.bizCert = member.value.bizCert || ''
  form.zipcode = String(member.value.zipcode || '').replace(/\D/g, '').slice(0, 5)
  form.address = member.value.address || ''
  form.addressDetail = member.value.addressDetail || ''
  form.refundBank = member.value.refundBank || ''
  form.refundAccount = String(member.value.refundAccount || '').replace(/\D/g, '')
  form.refundHolder = member.value.refundHolder || ''
  form.emailCode = ''
  form.phoneCode = ''
  originalEmail.value = normalizeEmail(form.email)
  originalPhone.value = form.phone
  emailVerification.reset()
  phoneVerification.reset()
  originalSnapshot.value = snapshotForm()
}

const onBizCertChange = async (event: Event) => {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (!file) return

  bizCertUploading.value = true
  try {
    const uploaded = await uploadMemberBizCert(file)
    form.bizCert = uploaded.url
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '사업자등록증 업로드에 실패했습니다.')
  } finally {
    bizCertUploading.value = false
    input.value = ''
  }
}

async function onSearchAddress() {
  try {
    const result = await searchPostcode()
    if (!result) return
    form.zipcode = result.zipcode
    form.address = result.extra ? `${result.address} ${result.extra}` : result.address
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '주소 검색에 실패했습니다.')
  }
}

watch(
  () => member.value?.mCode,
  () => {
    applyMemberToForm()
  },
  { immediate: true },
)

watch(
  () => form.email,
  () => {
    form.emailCode = ''
    emailVerification.reset()
  },
)

watch(
  () => form.phone,
  () => {
    form.phoneCode = ''
    phoneVerification.reset()
  },
)

onBeforeRouteLeave(() => {
  if (skipLeaveGuard.value || !isDirty.value) {
    return true
  }

  return window.confirm('저장하지 않은 변경 내용이 있습니다.\n다른 페이지로 이동하시겠습니까?')
})

onMounted(() => {
  loadBizGubunOptions()
})

const loadBizGubunOptions = async () => {
  bizGubunLoading.value = true
  bizGubunLoadError.value = ''

  try {
    bizGubunOptions.value = await fetchBizGubunList()
  } catch (error) {
    bizGubunLoadError.value =
      error instanceof Error ? error.message : '사업구분 목록을 불러오지 못했습니다.'
  } finally {
    bizGubunLoading.value = false
  }
}

const onOrgNameInput = (event: Event) => {
  form.orgName = sanitizeOrgNameInput((event.target as HTMLInputElement).value)
}

const onOrgCodeInput = (event: Event) => {
  form.orgCode = sanitizeDigitsInput((event.target as HTMLInputElement).value, 11)
}

const onNameInput = (event: Event) => {
  form.name = sanitizeNameInput((event.target as HTMLInputElement).value)
}

const onPhoneInput = (event: Event) => {
  form.phone = sanitizeDigitsInput((event.target as HTMLInputElement).value, 11)
}

const onEmailCodeInput = (event: Event) => {
  form.emailCode = sanitizeDigitsInput((event.target as HTMLInputElement).value, 6)
}

const onPhoneCodeInput = (event: Event) => {
  form.phoneCode = sanitizeDigitsInput((event.target as HTMLInputElement).value, 6)
}

const onOrgNameEnter = () => {
  focusInput(orgCodeRef)
}

const onOrgCodeEnter = () => {
  if (isOrgCodeValid(form.orgCode)) {
    focusInput(nameRef)
  }
}

const onNameEnter = () => {
  focusInput(emailRef)
}

const onEmailEnter = () => {
  if (isEmailChanged.value && !emailVerification.verified) {
    focusInput(emailCodeRef)
    return
  }
  focusInput(phoneRef)
}

const onEmailCodeEnter = () => {
  verifyEmail()
}

const onPhoneEnter = () => {
  if (isPhoneChanged.value && !phoneVerification.verified) {
    focusInput(phoneCodeRef)
    return
  }
  onSubmit()
}

const onPhoneCodeEnter = () => {
  verifyPhone()
}

const sendEmailCode = async () => {
  try {
    await emailVerification.sendEmail(form.email)
  } catch {
    // errorMessage는 폼에 표시
  }
}

const verifyEmail = async () => {
  try {
    await emailVerification.verifyEmail(form.email, form.emailCode)
  } catch {
    // errorMessage는 폼에 표시
  }
}

const sendPhoneCode = async () => {
  try {
    await phoneVerification.sendPhone(form.phone)
  } catch {
    // errorMessage는 폼에 표시
  }
}

const verifyPhone = async () => {
  try {
    await phoneVerification.verifyPhone(form.phone, form.phoneCode)
  } catch {
    // errorMessage는 폼에 표시
  }
}

const onSubmit = () => {
  formSubmitAttempted.value = true

  if (!isDirty.value) {
    window.alert('변경된 내용이 없습니다.')
    return
  }

  const errors = collectProfileValidationErrors({
    form,
    emailChanged: isEmailChanged.value,
    phoneChanged: isPhoneChanged.value,
    emailVerified: isEmailReady.value,
    phoneVerified: isPhoneReady.value,
  })

  if (errors.length > 0) {
    window.alert(`다음 항목을 확인해 주세요.\n\n${errors.map((item) => `• ${item}`).join('\n')}`)
    return
  }

  if (!window.confirm('변경한 내용을 저장하시겠습니까?')) {
    return
  }

  saveProfile()
}

const saveProfile = async () => {
  if (isSubmitting.value) {
    return
  }

  isSubmitting.value = true

  try {
    const updatedMember = await updateMemberProfile({
      orgName: form.orgName,
      orgCode: form.orgCode,
      bizGubun: serializeBizGubun(form.bizGubun),
      name: form.name,
      email: form.email,
      phone: form.phone,
      bizNum: form.bizNum,
      bizCert: form.bizCert,
      zipcode: form.zipcode,
      address: form.address,
      addressDetail: form.addressDetail,
      refundBank: form.refundBank,
      refundAccount: form.refundAccount,
      refundHolder: form.refundHolder,
    })

    setMember(updatedMember)
    applyMemberToForm()
    skipLeaveGuard.value = true
    window.alert('내 정보가 저장되었습니다.')
  } catch (error) {
    const message = error instanceof Error ? error.message : '내 정보 저장에 실패했습니다.'
    window.alert(message)
  } finally {
    isSubmitting.value = false
  }
}

const onLogout = async () => {
  if (isDirty.value && !window.confirm('저장하지 않은 변경 내용이 있습니다.\n로그아웃하시겠습니까?')) {
    return
  }

  skipLeaveGuard.value = true
  await logout()
  await router.push({ name: 'dashboard' })
}

const onWithdraw = async () => {
  if (withdrawing.value) {
    return
  }
  if (
    !window.confirm(
      '정말 탈퇴할까요?\n카카오 계정이면 같은 카카오로 다시 가입할 수 있습니다.\n주문 기록은 보관됩니다.',
    )
  ) {
    return
  }
  withdrawing.value = true
  skipLeaveGuard.value = true
  try {
    await withdraw()
    window.alert('탈퇴가 완료되었습니다.')
    await router.push({ name: 'dashboard' })
  } catch (error) {
    skipLeaveGuard.value = false
    window.alert(error instanceof Error ? error.message : '탈퇴에 실패했습니다.')
  } finally {
    withdrawing.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[51] || (_cache[51] = _createElementVNode("header", { class: "auth-page__head" }, [
        _createElementVNode("p", { class: "auth-page__eyebrow" }, "마이페이지"),
        _createElementVNode("h1", { class: "auth-page__title" }, "내 정보"),
        _createElementVNode("p", { class: "auth-page__desc" }, " 필요한 항목만 적으면 됩니다. 배송지·연락처는 주문할 때, 환불 계좌는 취소·반품할 때도 받을 수 있습니다. 이미 있는 이메일·휴대폰을 바꾸면 인증이 필요합니다. ")
      ], -1)),
      (_unref(member))
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            class: "auth-page__panel auth-form my-info-form",
            onSubmit: _withModifiers(onSubmit, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("section", _hoisted_4, [
                _cache[23] || (_cache[23] = _createElementVNode("h2", { class: "auth-form__section-title" }, "계정", -1)),
                (isKakaoMember.value)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_5, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", null, "로그인", -1)),
                      _createElementVNode("input", {
                        value: kakaoAccountLabel.value,
                        type: "text",
                        disabled: ""
                      }, null, 8, _hoisted_6),
                      _cache[16] || (_cache[16] = _createElementVNode("p", { class: "auth-form__hint" }, "카카오 계정으로 들어가셨습니다. 아이디와 비밀번호는 없습니다.", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("label", _hoisted_7, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", null, "아이디", -1)),
                      _createElementVNode("input", {
                        value: _unref(member).userId,
                        type: "text",
                        autocomplete: "username",
                        disabled: ""
                      }, null, 8, _hoisted_8),
                      _cache[18] || (_cache[18] = _createElementVNode("p", { class: "auth-form__hint" }, "아이디는 변경할 수 없습니다.", -1))
                    ])),
                _createElementVNode("div", _hoisted_9, [
                  (!isKakaoMember.value)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/find-password",
                        class: "auth-form__link"
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode(" 비밀번호 변경 ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_router_link, {
                    to: "/mall/mypage",
                    class: "auth-form__link my-info-form__mall-link"
                  }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createTextVNode(" 함우리몰 마이쇼핑 ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/mall/mypage/orders",
                    class: "auth-form__link my-info-form__mall-link"
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createTextVNode(" 주문내역 ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/mall/mypage/shipping",
                    class: "auth-form__link my-info-form__mall-link"
                  }, {
                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                      _createTextVNode(" 배송지 관리 ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("section", _hoisted_10, [
                _cache[33] || (_cache[33] = _createElementVNode("h2", { class: "auth-form__section-title" }, "기관 정보", -1)),
                _cache[34] || (_cache[34] = _createElementVNode("p", { class: "auth-form__section-desc" }, "나중에 적어도 됩니다. 주문에 필수는 아닙니다.", -1)),
                _createElementVNode("label", _hoisted_11, [
                  _cache[24] || (_cache[24] = _createElementVNode("span", null, "기관명", -1)),
                  _withDirectives(_createElementVNode("input", {
                    ref_key: "orgNameRef",
                    ref: orgNameRef,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.orgName) = $event)),
                    type: "text",
                    placeholder: "기관명을 입력해 주세요",
                    maxlength: "50",
                    class: _normalizeClass(orgNameInputState.value),
                    onInput: onOrgNameInput,
                    onKeydown: _withKeys(_withModifiers(onOrgNameEnter, ["prevent"]), ["enter"])
                  }, null, 42, _hoisted_12), [
                    [_vModelText, form.orgName]
                  ])
                ]),
                _createElementVNode("label", _hoisted_13, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", null, "기관 기호", -1)),
                  _withDirectives(_createElementVNode("input", {
                    ref_key: "orgCodeRef",
                    ref: orgCodeRef,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.orgCode) = $event)),
                    type: "text",
                    inputmode: "numeric",
                    autocomplete: "off",
                    placeholder: "장기요양기관기호 11자리",
                    maxlength: "11",
                    class: _normalizeClass(orgCodeInputState.value),
                    onInput: onOrgCodeInput,
                    onKeydown: _withKeys(_withModifiers(onOrgCodeEnter, ["prevent"]), ["enter"])
                  }, null, 42, _hoisted_14), [
                    [_vModelText, form.orgCode]
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("p", { class: "auth-form__hint" }, " 국민건강보험공단에 등록된 장기요양기관기호 11자리 숫자입니다. ", -1))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[27] || (_cache[27] = _createElementVNode("span", null, "사업 구분", -1)),
                  _createVNode(BizGubunPicker, {
                    modelValue: form.bizGubun,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.bizGubun) = $event)),
                    options: bizGubunOptionsWithLegacy.value,
                    loading: bizGubunLoading.value,
                    "load-error": bizGubunLoadError.value
                  }, null, 8, ["modelValue", "options", "loading", "load-error"])
                ]),
                _createElementVNode("label", _hoisted_16, [
                  _cache[28] || (_cache[28] = _createElementVNode("span", null, "사업자등록번호", -1)),
                  _createElementVNode("input", {
                    value: form.bizNum,
                    type: "text",
                    inputmode: "numeric",
                    placeholder: "000-00-00000",
                    maxlength: "12",
                    class: _normalizeClass(_unref(bizNumberFieldState)(form.bizNum)),
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (form.bizNum = _unref(formatBizNumberInput)(($event.target as HTMLInputElement).value)))
                  }, null, 42, _hoisted_17),
                  (_unref(bizNumberInputError)(form.bizNum))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_unref(bizNumberInputError)(form.bizNum)), 1))
                    : (_unref(isBizNumberInputValid)(form.bizNum))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, " 번호가 맞습니다. "))
                      : (_openBlock(), _createElementBlock("p", _hoisted_20, " 숫자만 넣으면 됩니다. 하이픈(-)은 알아서 들어갑니다. "))
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[30] || (_cache[30] = _createElementVNode("span", null, "사업자등록증", -1)),
                  _createElementVNode("input", {
                    type: "file",
                    accept: ".jpg,.jpeg,.png,.webp,.pdf,image/*,application/pdf",
                    disabled: bizCertUploading.value,
                    onChange: onBizCertChange
                  }, null, 40, _hoisted_22),
                  (bizCertUploading.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, "업로드 중..."))
                    : (form.bizCert)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                          _cache[29] || (_cache[29] = _createTextVNode(" 등록증이 등록되어 있습니다. ", -1)),
                          _createElementVNode("a", {
                            href: bizCertHref.value,
                            target: "_blank",
                            rel: "noopener",
                            class: "auth-form__link"
                          }, "미리보기", 8, _hoisted_25)
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_26, "jpg · png · webp · pdf (최대 10MB)"))
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _cache[31] || (_cache[31] = _createElementVNode("span", null, "기관 주소", -1)),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("input", {
                        value: form.zipcode,
                        type: "text",
                        placeholder: "우편번호",
                        readonly: "",
                        class: _normalizeClass(_unref(inputValidationState)(form.zipcode, _unref(isZipcodeValid)(form.zipcode))),
                        onClick: onSearchAddress
                      }, null, 10, _hoisted_30),
                      _createElementVNode("button", {
                        type: "button",
                        class: "auth-form__inline-btn",
                        disabled: _unref(postcodeOpening),
                        onClick: onSearchAddress
                      }, " 주소 검색 ", 8, _hoisted_31)
                    ]),
                    _createElementVNode("input", {
                      value: form.address,
                      type: "text",
                      placeholder: "주소 검색을 눌러 주세요",
                      readonly: "",
                      class: _normalizeClass(_unref(inputValidationState)(form.address, _unref(isAddressValid)(form.address))),
                      onClick: onSearchAddress
                    }, null, 10, _hoisted_32),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.addressDetail) = $event)),
                      type: "text",
                      maxlength: "100",
                      placeholder: "상세 주소 (동·호수 등)",
                      class: _normalizeClass(_unref(inputValidationState)(form.addressDetail, _unref(isAddressDetailValid)(form.addressDetail)))
                    }, null, 2), [
                      [
                        _vModelText,
                        form.addressDetail,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _cache[32] || (_cache[32] = _createElementVNode("p", { class: "auth-form__hint" }, "세금계산서·배송 안내에 사용됩니다.", -1))
                ])
              ]),
              _createElementVNode("section", _hoisted_33, [
                _cache[39] || (_cache[39] = _createElementVNode("h2", { class: "auth-form__section-title" }, "환불 계좌", -1)),
                _cache[40] || (_cache[40] = _createElementVNode("p", { class: "auth-form__section-desc" }, " 지금 적어도 되고, 취소·반품할 때 적어도 됩니다. 그때 적은 계좌가 회원 환불계좌가 됩니다. ", -1)),
                _createElementVNode("label", _hoisted_34, [
                  _cache[36] || (_cache[36] = _createElementVNode("span", null, "은행", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.refundBank) = $event))
                  }, [
                    _cache[35] || (_cache[35] = _createElementVNode("option", { value: "" }, "은행을 선택해 주세요", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MEMBER_REFUND_BANKS), (bank) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: bank,
                        value: bank
                      }, _toDisplayString(bank), 9, _hoisted_35))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, form.refundBank]
                  ])
                ]),
                _createElementVNode("label", _hoisted_36, [
                  _cache[37] || (_cache[37] = _createElementVNode("span", null, "계좌번호", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.refundAccount) = $event)),
                    type: "text",
                    inputmode: "numeric",
                    placeholder: "숫자만 입력",
                    maxlength: "20",
                    class: _normalizeClass(_unref(inputValidationState)(form.refundAccount, _unref(isRefundAccountValid)(form.refundAccount))),
                    onInput: _cache[7] || (_cache[7] = ($event: any) => (form.refundAccount = _unref(sanitizeDigitsInput)(($event.target as HTMLInputElement).value, 20)))
                  }, null, 34), [
                    [_vModelText, form.refundAccount]
                  ])
                ]),
                _createElementVNode("label", _hoisted_37, [
                  _cache[38] || (_cache[38] = _createElementVNode("span", null, "예금주", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.refundHolder) = $event)),
                    type: "text",
                    placeholder: "예금주명",
                    maxlength: "50",
                    class: _normalizeClass(_unref(inputValidationState)(form.refundHolder, _unref(isRefundHolderValid)(form.refundHolder)))
                  }, null, 2), [
                    [
                      _vModelText,
                      form.refundHolder,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_38, [
                _cache[42] || (_cache[42] = _createElementVNode("h2", { class: "auth-form__section-title" }, "담당자", -1)),
                _createElementVNode("label", _hoisted_39, [
                  _cache[41] || (_cache[41] = _createElementVNode("span", null, "이름", -1)),
                  _withDirectives(_createElementVNode("input", {
                    ref_key: "nameRef",
                    ref: nameRef,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.name) = $event)),
                    type: "text",
                    autocomplete: "name",
                    placeholder: "이름을 입력해 주세요",
                    maxlength: "20",
                    class: _normalizeClass(nameInputState.value),
                    onInput: onNameInput,
                    onBlur: _cache[10] || (_cache[10] = ($event: any) => (nameTouched.value = true)),
                    onKeydown: _withKeys(_withModifiers(onNameEnter, ["prevent"]), ["enter"])
                  }, null, 42, _hoisted_40), [
                    [_vModelText, form.name]
                  ]),
                  (showNameWarning.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_41, " 한글 2자 이상 입력해 주세요. "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("section", _hoisted_42, [
                _cache[49] || (_cache[49] = _createElementVNode("h2", { class: "auth-form__section-title" }, "연락처 · 본인 인증", -1)),
                _cache[50] || (_cache[50] = _createElementVNode("p", { class: "auth-form__section-desc" }, " 가입 시 인증한 연락처입니다. 변경할 때만 인증번호 확인이 필요합니다. ", -1)),
                _createElementVNode("div", _hoisted_43, [
                  _cache[43] || (_cache[43] = _createElementVNode("span", null, "이메일", -1)),
                  _createElementVNode("div", _hoisted_44, [
                    _withDirectives(_createElementVNode("input", {
                      ref_key: "emailRef",
                      ref: emailRef,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.email) = $event)),
                      type: "email",
                      autocomplete: "email",
                      placeholder: "example@email.com",
                      class: _normalizeClass(emailInputState.value),
                      disabled: isEmailInputLocked.value,
                      onKeydown: _withKeys(_withModifiers(onEmailEnter, ["prevent"]), ["enter"])
                    }, null, 42, _hoisted_45), [
                      [_vModelText, form.email]
                    ]),
                    (isEmailChanged.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: _normalizeClass(["auth-form__inline-btn", { 'auth-form__inline-btn--done': _unref(emailVerification).codeSent }]),
                          disabled: !_unref(isEmailValid)(form.email) || _unref(emailVerification).verified || _unref(emailVerification).sending || _unref(emailVerification).resendIn > 0,
                          onClick: sendEmailCode
                        }, _toDisplayString(_unref(emailVerification).sendActionLabel('인증발송', '재발송')), 11, _hoisted_46))
                      : _createCommentVNode("", true)
                  ]),
                  (!isEmailChanged.value)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass(["auth-form__msg", _unref(member).emailVerified ? 'auth-form__msg--ok' : 'auth-form__msg--muted'])
                      }, _toDisplayString(_unref(member).emailVerified ? '인증된 이메일입니다.' : '등록된 이메일입니다.'), 3))
                    : (_unref(emailVerification).errorMessage && !_unref(emailVerification).codeSent)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(_unref(emailVerification).errorMessage), 1))
                      : (_unref(emailVerification).codeSent && !_unref(emailVerification).verified)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(form.email) + "으로 인증번호를 보냈습니다. 받은편지함과 스팸함을 확인해 주세요. ", 1))
                        : _createCommentVNode("", true)
                ]),
                (isEmailChanged.value && !_unref(emailVerification).verified)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _cache[45] || (_cache[45] = _createElementVNode("span", null, "이메일 인증번호", -1)),
                      _createElementVNode("div", _hoisted_50, [
                        _withDirectives(_createElementVNode("input", {
                          ref_key: "emailCodeRef",
                          ref: emailCodeRef,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.emailCode) = $event)),
                          type: "text",
                          inputmode: "numeric",
                          maxlength: "6",
                          placeholder: "인증번호 6자리",
                          class: _normalizeClass(emailCodeInputState.value),
                          disabled: !_unref(emailVerification).codeSent,
                          onInput: onEmailCodeInput,
                          onKeydown: _withKeys(_withModifiers(onEmailCodeEnter, ["prevent"]), ["enter"])
                        }, null, 42, _hoisted_51), [
                          [_vModelText, form.emailCode]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "auth-form__inline-btn",
                          disabled: !_unref(emailVerification).codeSent || !_unref(isVerifyCodeValid)(form.emailCode) || _unref(emailVerification).verifying,
                          onClick: verifyEmail
                        }, _toDisplayString(_unref(emailVerification).verifying ? '확인중...' : '확인'), 9, _hoisted_52)
                      ]),
                      (!_unref(emailVerification).codeSent)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_53, " 변경할 이메일로 인증번호를 발송해 주세요. "))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("p", _hoisted_54, [
                              _cache[44] || (_cache[44] = _createTextVNode(" 메일로 보낸 숫자 6자리를 적어 주세요. ", -1)),
                              (_unref(emailVerification).timer > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_unref(emailVerification).formatTimer(_unref(emailVerification).timer)) + " 남음 ", 1))
                                : _createCommentVNode("", true)
                            ]),
                            (_unref(emailVerification).errorMessage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(_unref(emailVerification).errorMessage), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]))
                  : _createCommentVNode("", true),
                (isEmailChanged.value && _unref(emailVerification).verified)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_57, " 이메일 인증이 완료되었습니다. "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_58, [
                  _cache[46] || (_cache[46] = _createElementVNode("span", null, "휴대폰 번호", -1)),
                  _createElementVNode("div", _hoisted_59, [
                    _withDirectives(_createElementVNode("input", {
                      ref_key: "phoneRef",
                      ref: phoneRef,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.phone) = $event)),
                      type: "tel",
                      inputmode: "numeric",
                      autocomplete: "tel",
                      placeholder: "01012345678",
                      maxlength: "11",
                      class: _normalizeClass(phoneInputState.value),
                      disabled: isPhoneInputLocked.value,
                      onInput: onPhoneInput,
                      onKeydown: _withKeys(_withModifiers(onPhoneEnter, ["prevent"]), ["enter"])
                    }, null, 42, _hoisted_60), [
                      [_vModelText, form.phone]
                    ]),
                    (isPhoneChanged.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: _normalizeClass(["auth-form__inline-btn", { 'auth-form__inline-btn--done': _unref(phoneVerification).codeSent }]),
                          disabled: !_unref(isPhoneValid)(form.phone) || _unref(phoneVerification).verified || _unref(phoneVerification).sending || _unref(phoneVerification).resendIn > 0,
                          onClick: sendPhoneCode
                        }, _toDisplayString(_unref(phoneVerification).sendActionLabel('인증발송', '재발송')), 11, _hoisted_61))
                      : _createCommentVNode("", true)
                  ]),
                  (!isPhoneChanged.value)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass(["auth-form__msg", _unref(member).phoneVerified ? 'auth-form__msg--ok' : 'auth-form__msg--muted'])
                      }, _toDisplayString(_unref(member).phoneVerified ? '인증된 휴대폰 번호입니다.' : '등록된 휴대폰 번호입니다.'), 3))
                    : (_unref(phoneVerification).errorMessage && !_unref(phoneVerification).codeSent)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(_unref(phoneVerification).errorMessage), 1))
                      : _createCommentVNode("", true)
                ]),
                (isPhoneChanged.value && !_unref(phoneVerification).verified)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _cache[48] || (_cache[48] = _createElementVNode("span", null, "휴대폰 인증번호", -1)),
                      _createElementVNode("div", _hoisted_64, [
                        _withDirectives(_createElementVNode("input", {
                          ref_key: "phoneCodeRef",
                          ref: phoneCodeRef,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.phoneCode) = $event)),
                          type: "text",
                          inputmode: "numeric",
                          maxlength: "6",
                          placeholder: "인증번호 6자리",
                          class: _normalizeClass(phoneCodeInputState.value),
                          disabled: !_unref(phoneVerification).codeSent,
                          onInput: onPhoneCodeInput,
                          onKeydown: _withKeys(_withModifiers(onPhoneCodeEnter, ["prevent"]), ["enter"])
                        }, null, 42, _hoisted_65), [
                          [_vModelText, form.phoneCode]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "auth-form__inline-btn",
                          disabled: !_unref(phoneVerification).codeSent || !_unref(isVerifyCodeValid)(form.phoneCode) || _unref(phoneVerification).verifying,
                          onClick: verifyPhone
                        }, _toDisplayString(_unref(phoneVerification).verifying ? '확인중...' : '확인'), 9, _hoisted_66)
                      ]),
                      (!_unref(phoneVerification).codeSent)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_67, " 변경할 휴대폰 번호로 인증번호를 발송해 주세요. "))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("p", _hoisted_68, [
                              _cache[47] || (_cache[47] = _createTextVNode(" 인증번호가 발송되었습니다. ", -1)),
                              (_unref(phoneVerification).timer > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_unref(phoneVerification).formatTimer(_unref(phoneVerification).timer)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (_unref(phoneVerification).errorMessage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_70, _toDisplayString(_unref(phoneVerification).errorMessage), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]))
                  : _createCommentVNode("", true),
                (isPhoneChanged.value && _unref(phoneVerification).verified)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_71, " 휴대폰 인증이 완료되었습니다. "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn-primary auth-form__submit",
                disabled: isSubmitting.value || !isDirty.value
              }, _toDisplayString(isSubmitting.value ? '저장 중...' : '저장'), 9, _hoisted_73),
              _createElementVNode("button", {
                type: "button",
                class: "btn-secondary auth-form__secondary",
                onClick: onLogout
              }, " 로그아웃 ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "my-info-form__withdraw",
              disabled: withdrawing.value,
              onClick: onWithdraw
            }, _toDisplayString(withdrawing.value ? '탈퇴 중...' : '계정 탈퇴'), 9, _hoisted_74)
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})